import { FunctionComponent } from 'react';
import OtherTransactionInfo from './OtherTransactionInfo';

type OtherTransactionContainerProps = {
  jwt?: string;
};

const OtherTransactionContainer: FunctionComponent<OtherTransactionContainerProps> = ({ jwt }) => {
  return (
    <div>
      <OtherTransactionInfo jwt={jwt} />
    </div>
  );
};

export default OtherTransactionContainer;
